import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";

import { FieldElementBlock } from "../../blocks/shared/components/FieldElementBlock";

interface NumberBlockMeta {
  elementableId: number;
  elementId: number;
  fieldIndex: number;
  position: number;
  profileFieldId?: number | null;
}

export interface FormNumberBlockProps extends ComponentPropsWithRef<"div"> {
  blockInstanceMeta?: NumberBlockMeta;
  hidden?: boolean;
  label?: string;
  placeholder?: string;
  required?: boolean;
}

export const FormNumberBlock = forwardRef<HTMLDivElement, FormNumberBlockProps>(
  (
    {
      label = "Number",
      placeholder = "",
      required = false,
      hidden = false,
      blockInstanceMeta = {},
      ...rest
    },
    ref,
  ) => (
    <FieldElementBlock
      ref={ref}
      blockInstanceMeta={blockInstanceMeta}
      fieldType="number"
      hidden={hidden}
      label={label}
      placeholder={placeholder}
      required={required}
      {...rest}
    />
  ),
);

FormNumberBlock.displayName = "FormNumberBlock";
